import PrivacyPolicy from './PrivacyPolicy'
import TermsOfService from './TermsOfService'

export const PolicyPages = {
  PrivacyPolicy,
  TermsOfService,
}
